import React, { useEffect, useState } from "react";
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";
import WidgetImage from "../../components/WidgetImage";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./BosIconSelectorWidget.module.scss";

export function BosIconSelectorWidget(props) {
  const { ui, config, data, doAction, dataSegment } = props;
  const [previewImage, setPreviewImage] = useState("");

  let widgetId = ui.id;
  let disabled = ui.readonly || (data && data.readonly);

  let content = data && data.content ? JSON.parse(data.content) : "";
  let valueContent = content && content.FileId ? content.FileId : "";
  let selectActionId = config ? config.SelectActionId : null;

  useEffect(() => {
    console.log("BosIconSelectorWidget data of " + ui.id + ": ", data);
    if (valueContent)
      setPreviewImage(BosFilesServices.getProtectedWebResourceUrl(dataSegment.authToken, valueContent));
    else
      setPreviewImage();
  }, [data]);

  const selectNewIcon = async (event) => {
    if (disabled) return;
    await doAction(selectActionId)
  };

  return (
    <div className={classes.picWrapper} id={widgetId}>
      <div className={cn(classes.imageWrapper, "dx-texteditor", "dx-editor-outlined")}>
        {previewImage
          ? <WidgetImage mode={"FitCenter"} src={previewImage} disabled={true} />
          : null
        }
      </div>
      <div>
        {disabled
          ? null
          : (
            <Button
              className={classes.button}
              icon="file"
              stylingMode="text"
              onClick={(e) => selectNewIcon(e)}
            />
          )
        }
      </div>
    </div>
  );
}
